import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

import { PayModeLevel1, PayModeLevel2 } from '@fitness-force/enum';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency'
import { TranslateModule } from '@ngx-translate/core';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'report-summary',
  templateUrl: './report-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    CurrencyformatPipe,
    StyleClassModule,
    TranslateModule,
  ]
})
export class ReportSummaryComponent implements OnInit {
  @Input('reportKey') reportKey: string = '';
  @Input('statisticsData') statisticsData: any;
  @Input('total') total: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  getTotalAmount() {
    if (this.reportKey.toLowerCase() == 'paymentreport') {
      return this.statisticsData.reduce((total: any, current: { amt: any; }) => total + current.amt, 0);
    }
    if (this.reportKey.toLowerCase() == 'salesbyservicecategory' || this.reportKey.toLowerCase() == 'invoicedetail') {
      return this.statisticsData.reduce((total: any, current: { total_payments: any; }) => total + current.total_payments, 0);
    }
  }

  getTaxTotal() {
    if (this.reportKey.toLowerCase() == 'salesbyservicecategory' || this.reportKey.toLowerCase() == 'invoicedetail') {
      return this.statisticsData.reduce((total: any, current: { tax_amount: any; }) => total + current.tax_amount, 0);
    }
  }

  getMode(value: number, data: any) {
    if (value > 0) {
      if (PayModeLevel2[value] == PayModeLevel2[PayModeLevel1.Other]) {
        return data.paymodemst_name_pri_lang || '-';
      }
      else {
        return PayModeLevel2[value];
      }
    }
    else {
      if (value == 0 && (data.paymodemst_name_pri_lang != "" || data.paymodemst_name_sec_lang != "")) {
        return data.paymodemst_name_pri_lang || data.paymodemst_name_sec_lang || '-';
      }
      else {
        return "-";
      }
    }
  }

  getDistinctServiceCategories(data: any[]) {
    // Use reduce to group by servicecategoryid
    const groupedServices = data.reduce((acc, curr) => {
      const key = curr.servicecategoryid;
      if (!acc[key]) {
        acc[key] = {
          servicecategoryid: curr.servicecategoryid,
          servicecategoryprimaryname: curr.servicecategoryprimaryname,
          count: 0
        };
      }
      acc[key].count++;
      return acc;
    }, {} as Record<number, { servicecategoryid: number; servicecategoryprimaryname: string; count: number }>);
  
    // Convert the grouped object back to array
    return Object.values(groupedServices);
  }

  getTotal() {
    if (this.reportKey.toLowerCase() == 'countbymembercategorywise') {
      return this.statisticsData.reduce((total: any, current: { cnt: any; }) => total + current.cnt, 0);
    }
  }

}
